import adminRoutes from './admin';
import authRoutes from './auth';
import clientRoutes from './client';
import commonRoutes from './common';
import {preparePaths} from './helpers';
import winningRoutes from './winning';

export const routePaths = {
  client: preparePaths(clientRoutes),
  common: preparePaths(commonRoutes),
  auth: preparePaths(authRoutes),
  admin: preparePaths(adminRoutes),
  winning: preparePaths(winningRoutes),
};
